var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#668bff;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-6,.cls-7{stroke:#000;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-6,.cls-7,.cls-8{stroke-linecap:round;}.cls-1,.cls-8{stroke-miterlimit:10;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-8{stroke-width:5px;}.cls-2{fill:#f2f2f2;}.cls-2,.cls-3,.cls-4,.cls-6,.cls-7{stroke-linejoin:round;}.cls-3{fill:#ff8159;}.cls-4,.cls-6,.cls-7,.cls-8{fill:none;}.cls-5{fill:#070606;}.cls-6{stroke-width:5.61px;}.cls-7{stroke-width:6px;}.cls-8{stroke:#f2f2f2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1147,1200H53c0-.67,0-1.34,0-2,.9-72.15,50.39-153.64,50.39-153.64L180,1005.28l1.08-.55L277,955.8l1.62-.82,100.81-51.43,1.69-.85,18.74-9.56c1.33-.76,5.62-2,12.08-3.55,12.84-3.09,34.28-7.5,58.16-12.19l1.61-.31c9.17-1.8,18.7-3.64,28.21-5.45C550,862.1,600,853.11,600,853.11s56.1,10.09,109,20.23c10.5,2,20.89,4,30.66,6l1.12.22c8.92,1.77,17.33,3.49,24.86,5.08,18.66,3.91,32,7.06,34.52,8.51l32.57,16.61,1.92,1L935.18,962l1.92,1,95.51,48.71,1.62.83,62.37,31.81s49.49,81.49,50.39,153.64C1147,1198.66,1147,1199.33,1147,1200Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.68,832.36c-8.9,5.93-51.88,61.12-17.05,72.07s215.69,31.7,254.23-11.29c16.31-20.75-34.09-62.26-34.09-62.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 499.94,
    y: 815.32,
    width: 209.02,
    height: 155.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M633.24,1199.86H566.3c9.32-54.51,19-104.18,26.56-126.07,2.59-7.55,4.93-11.79,6.9-11.79s4.6,4.79,7.39,13.24C614.61,1097.8,624.11,1146.51,633.24,1199.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M526.62,1025.79s58.56,48.21,71.9,51.17,70.3-51.17,70.3-51.17L647.44,951H549.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M486.37,1198l8-174.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M727.39,1200l-7.74-185.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M500.68,835s-43,35.94-28.17,59.66,84.5,25.2,136.38,25.2,115.63-5.93,129-26.69-33.7-61.66-33.7-61.66l100.41,86.86c11.86,41.51-130.45,126-130.45,126L647.44,951l-93.39-1.49L520,1044.35S384.07,940,401.36,896.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M167.44,1198l-.2,2h-.13l.14-2L180,1005.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M264.81,1198q-.07,1.11-.15,2h-.1l.1-2L277,955.8S267.19,1167.35,264.81,1198Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M367.25,1198c-.05.74-.1,1.41-.14,2H367l.09-2,12.34-294.44S369.43,1163.84,367.25,1198Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1046.52,1200c-.06-.6-12.29-187.46-12.29-187.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M949.1,1200,935.17,962Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M846.65,1200l-12-289.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1147,1198c0,.67,0,1.34,0,2H53c0-.67,0-1.34,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M607.93,1085.76a26.55,26.55,0,0,1-12.06,1.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M588.72,1094.25a109.36,109.36,0,0,0,14.53,2.21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M830.81,500.65s63.28-4.79,63.28,56-70.9,83.86-70.9,83.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M365,500.65s-62-4.79-62,56S372.6,640.5,372.6,640.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M838.67,538.11c0,174-63.75,315-240.15,315s-240.15-141-240.15-315S414.7,211.24,598.52,211.24,838.67,364.13,838.67,538.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M581.47,615.93a34.1,34.1,0,1,0,0-68.19v-60"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M483.63,269.79c27.4,10.54,185.3,13.34,201.61-5.93,0,0,97.84,38.55,91.91,99.32s46,200.13,53.36,169,5.75-34.06,18.44-31.11S886.25,472,869.06,381c-11.86-97.84-75.61-222.36-278.7-222.36S322.05,336.5,325,404.69s0,84.5,20.76,96.36,13.34,31.13,23.72,43,41.5-167.51,43-194.2S464.36,262.38,483.63,269.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M659.06,524.28c0-28.13,72.13-28.13,72.13,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M454.15,524.28c0-28.13,72.13-28.13,72.13,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M431.07,472.4c11-28.65,110-30.09,118.29,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M754.27,472.4c-11-28.65-110-30.09-118.29,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 516.24,
    y1: 625.57,
    x2: 483.63,
    y2: 640.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 540.1,
    y1: 640.14,
    x2: 513.15,
    y2: 655.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 663.13,
    y1: 625.57,
    x2: 695.75,
    y2: 640.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 639.28,
    y1: 640.14,
    x2: 666.23,
    y2: 655.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M500.68,676c0,64.86,195.68,64.65,195.68,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 772.07,
    y1: 686.74,
    x2: 805,
    y2: 714.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 756.78,
    y1: 715.49,
    x2: 792.5,
    y2: 749.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 741.49,
    y1: 736.74,
    x2: 766.87,
    y2: 774.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 726.2,
    y1: 761.74,
    x2: 741.49,
    y2: 796.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 703.96,
    y1: 779.24,
    x2: 719.95,
    y2: 816.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 674.78,
    y1: 789.24,
    x2: 685.9,
    y2: 830.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 641.42,
    y1: 797.99,
    x2: 652.32,
    y2: 842.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 608.06,
    y1: 800.49,
    x2: 605.28,
    y2: 845.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 566.36,
    y1: 794.24,
    x2: 560.57,
    y2: 845.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M527.45,789.24,508,830.49"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 494.09,
    y1: 774.24,
    x2: 460.75,
    y2: 809.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 460.73,
    y1: 749.24,
    x2: 428.76,
    y2: 774.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 438.49,
    y1: 721.74,
    x2: 403.74,
    y2: 735.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M360.55,426.26l4.3-8.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M357.68,343.17a26.72,26.72,0,0,0,10-5.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M396.36,298.76v8.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M419.27,264.36a34,34,0,0,0,7.22-12.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M469.46,234.16a27.91,27.91,0,0,1,12.81,7.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M536.59,199.74l7.13-7.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M543.84,240.17l7.16,4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M596.9,252.88l8.69-5.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M593,216.93l-4.53-8.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M683,245.89l5.69-5.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M660.06,211.32l-2.64-4.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M748.69,234.22a7.2,7.2,0,0,1,5.82-2.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M740.21,267.24l3.84,13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M800.35,290.17h10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M793.1,363.21a35.53,35.53,0,0,1-3.92,11.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M826.06,393.42l10.09,7.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M851.77,435l8.84,8.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M830.55,469.32,822.24,481"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M817.58,444.93a29.33,29.33,0,0,0-7.44,9.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M364.84,479.29a6.47,6.47,0,0,1,4.33,4.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M827.6,341.77l8.58-7.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M344.79,379l7.16,7.16"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar01);
export default __webpack_public_path__ + "static/media/Avatar-01.a6011fb68bc4441a75336dde062c3a69.svg";
export { ForwardRef as ReactComponent };